/**
 * Is the trainer step (name and level) up for this account, and which face?
 *
 * One hook for everything that needs to know: the ProfileGate, which renders
 * the step, and SessionProvider, which holds the tour and the timed prompts
 * back while it is open. The rule itself is lib/trainerSetup.trainerStepKind;
 * this binds it to the two bits of device state it depends on.
 */
import { useSyncExternalStore } from "react";
import {
  isProfileSetupRequested,
  isTrainerConfirmDeferred,
  subscribeProfileSetupRequest,
} from "./profileSetupRequest";
import { trainerStepKind } from "./trainerSetup";

type StepAccount = Parameters<typeof trainerStepKind>[0] & { id: number };

export function useTrainerStepKind(account: StepAccount | null | undefined): "setup" | "confirm" | null {
  const requested = useSyncExternalStore(
    subscribeProfileSetupRequest,
    () => isProfileSetupRequested(account?.id),
    () => false,
  );
  const deferred = useSyncExternalStore(
    subscribeProfileSetupRequest,
    () => isTrainerConfirmDeferred(account?.id),
    () => false,
  );
  return trainerStepKind(account, { requested, deferred });
}
